import * as DsIcon from "@equipmentshare/ds-icon";
import { Dropdown, Menu, notification } from "antd";

import { MenuClickEventHandler, MenuInfo } from "rc-menu/lib/interface";
import React, { useState } from "react";

import { Button } from "~/ButtonV2";
import * as Icon from "~/Icon";
import * as Log from "~/Log";

import { Download } from "./Download";
import { DownloadReport } from "./PDFReport";

export type MenuStates = "Download CSV" | "Export PDF" | "None";

export function ExportMenu(route: Log.Route) {
  const [buttonIsDown, setButtonState] = useState<boolean>(true);
  const [selectedOption, setSelectedOption] = useState<string | number>(
    ExportMenu.buttonTitle()
  );

  const visibilityChange = (visible: boolean) => !visible && toggleMenu();

  const toggleMenu = () => {
    setButtonState(!buttonIsDown);
  };

  const onSelect = (info: MenuInfo) => {
    setSelectedOption(info.key);
    setButtonState(true);
  };

  const onComplete = (option: MenuStates) => {
    if (option === "Download CSV") {
      void notification.success({
        message: "Success",
        description: "Log data have been exported!",
        duration: 3,
        icon: (
          <DsIcon.Icon
            name="$icon_check_circle_fill"
            color="$color_primary_green"
          />
        ),
        placement: "topRight",
        onClose: () => setSelectedOption(ExportMenu.buttonTitle()),
      });
    } else if (option === "Export PDF") {
      void notification.success({
        message: "Success",
        description: "PDF Log report has been saved!",
        duration: 3,
        icon: (
          <DsIcon.Icon
            name="$icon_check_circle_fill"
            color="$color_primary_green"
          />
        ),
        placement: "topRight",
        onClose: () => setSelectedOption(ExportMenu.buttonTitle()),
      });
    }
  };

  return (
    <Dropdown
      overlay={ExportMenu.DropDownMenu({
        route,
        onClick: onSelect,
        onComplete,
      })}
      trigger={["click"]}
      onVisibleChange={visibilityChange}
    >
      <Button onClick={toggleMenu}>
        {selectedOption} {buttonIsDown ? <Icon.AngleDown /> : <Icon.AngleUp />}
      </Button>
    </Dropdown>
  );
}

export namespace ExportMenu {
  export const buttonTitle = () => "Export data" as const;

  export type DropDownMenuProps = {
    readonly route: Log.Route;
    readonly onClick: MenuClickEventHandler;
    readonly onComplete: (option: MenuStates) => void;
  };
  export function DropDownMenu(props: DropDownMenuProps) {
    return (
      <Menu onClick={props.onClick}>
        <Menu.Item key={"Download CSV"}>
          <Download
            route={props.route}
            onComplete={() => props.onComplete("Download CSV")}
          />
        </Menu.Item>
        <Menu.Item key={"Export PDF"}>
          <DownloadReport
            route={props.route}
            onComplete={() => props.onComplete("Export PDF")}
          />
        </Menu.Item>
      </Menu>
    );
  }
}
